module.exports = "'data:image/svg+xml;utf8,<svg width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\"><title>Arrow Up Copy 2</title><path d=\"M4.673 6.502L.706 2.535A1.124 1.124 0 0 1 .71.952C1.15.512 1.854.512 2.29.95l4.762 4.76c.215.216.324.502.324.79a1.1 1.1 0 0 1-.324.792l-4.762 4.762c-.43.43-1.145.435-1.583-.003a1.117 1.117 0 0 1-.004-1.582l3.967-3.966z\" fill=\"%2349B7FF\" fill-rule=\"evenodd\"/></svg>'"


/*****************
 ** WEBPACK FOOTER
 ** ./src/Toggle/arrowCollapsed.svg
 ** module id = 144
 ** module chunks = 0
 **/